export default (errObj) => {

    // scroll to top... so error msg is visible
    window.scrollTo(0, 0);

    let response = errObj.message;

    // check for ERROR MESSAGE transform record
    if (typeof CognitoErrors[errObj.code]) {
        for (let key in CognitoErrors[errObj.code]) {
            let haystack = new RegExp(key);
            if (haystack.test(errObj.message)) {
                if (CognitoErrors[errObj.code][key] != '') {
                    return CognitoErrors[errObj.code][key];
                }
            }

        }
    }

    return response;
}